import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { NewUiTreeselectComponent } from "../../shared/form/treeselect/new-ui-treeselect.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";

@Component({
  selector: "new-ui-formly-treeselect",
  templateUrl: "./new-ui-formly-treeselect.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NewUiTreeselectComponent, ReactiveFormsModule, FormlyModule, NewUiFormElementMapModule, Message],
})
export class NewUiFormlyTreeselectComponent extends FieldType {
  override defaultOptions = {
    props: { options: [], parentIdentifier: "parentId" },
  };
}
